import { useEffect, useRef, useState } from "react";

interface UseAutoplayProgressParams {
  duration:number,
  playbackStatus:string,
  startNextVideo:() => void
}

export function useAutoplayProgress({ duration, playbackStatus, startNextVideo }:UseAutoplayProgressParams) {
  const [progress, setProgress] = useState(0);
  const [shouldStartNextVideo, setShouldStartNextVideo] = useState(false);

  const intervalProgressRef = useRef<number|null>(null);
  const previousTimeRef = useRef<number|null>();
  const elapsedProgressTimeRef = useRef<number>(0);

  const animate = (time:number) => {
    if (previousTimeRef.current != null && playbackStatus !== "") {
      const deltaTime = time - previousTimeRef.current;
      elapsedProgressTimeRef.current += deltaTime;
      if (elapsedProgressTimeRef.current >= 100) {
        setProgress((prev) => {
          if (prev < 100) {
            return prev + (10 / Math.floor(duration));
          } 
          cancelAnimationFrame(intervalProgressRef.current || 0);
          // aspetto che il video si stato eseguito del tutto e poi chiamo startNextVideo
          if(playbackStatus === "stop"){
            setShouldStartNextVideo(true);
          }
          return 100;
          
        });
        elapsedProgressTimeRef.current -= 100;
      }
    }
    previousTimeRef.current = time;
    intervalProgressRef.current = requestAnimationFrame(animate);
  };

  // useEffect per gestire l'avvio del prossimo video fuori dal ciclo di rendering
  useEffect(() => {
    if (shouldStartNextVideo) {
      setShouldStartNextVideo(false);
      startNextVideo();
    }
  }, [shouldStartNextVideo, startNextVideo]);

  useEffect(() => {
    if(playbackStatus === "play"|| playbackStatus === "stop"){
      intervalProgressRef.current = requestAnimationFrame(animate);
      return;
    }

    cancelAnimationFrame(intervalProgressRef.current || 0);
    intervalProgressRef.current = null;
    previousTimeRef.current = null;
    elapsedProgressTimeRef.current = 0;
    
    return () =>{
      cancelAnimationFrame(intervalProgressRef.current || 0);
      intervalProgressRef.current = null;
      previousTimeRef.current = null;
      elapsedProgressTimeRef.current = 0;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playbackStatus]);

  return progress;
}
